// extracted by mini-css-extract-plugin
export default {"margin-100":"BudgetQuestion-module__margin-100__jdldT"};